/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import * as wjCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
// import { faFileExcel } from "@fortawesome/free-regular-svg-icons"
// import ExcelJS from "exceljs"
import dayjs from "dayjs"
// other
import { useEffect, useState } from "react"
import {
  Card,
  Col,
  Container,
  Row,
  Button,
  Table,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap"
import { useDispatch } from "react-redux"
import { useHistory, useLocation, useParams } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import TextInput from "../../../components/InputWrapper/TextInput"
import Spinner from "../../../components/Spinner"
import TeateEditModalV2 from "./TeateEditModalV2"
import CONST from "../../../constant"
import { clearAlert, setAlerts } from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import ZyomuinUnkoGeppoV2Service from "../../../service/driverpayroll/zyomuinUnkoGeppoV2/zyomuinUnkoGeppoV2Service"
import {
  TZyomuinUnkoGeppo2ListGetRes,
  TZyomuinUnkoGeppo2ListGetReq,
  TZyomuinUnkoGeppo2SummaryGetRes,
} from "../../../service/driverpayroll/zyomuinUnkoGeppoV2/TZyomuinUnkoGeppoV2"
import pageHelper from "../../../ts/helpers/pageHelper"
import { TWijmoCellTemplateContext } from "../../../type/wijmoComponents"
import { e勤怠区分, 乗務員勤怠表示記号区分 } from "../../../constant/enum/unko"
import { e付替区分, 受注配車区分 } from "../../../constant/enum/zyutuHaisya"
import SyainService from "../../../service/master/syain/syainService"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons"
import dateUtil from "../../../ts/util/dateUtil"

//#region [type]

export type T運行月報リスト = TZyomuinUnkoGeppo2ListGetRes & {
  行ID: symbol
}

//#endregion

/**
 * 乗務員 運行月報
 * @returns
 */
const ZyomuinUnkoGeppoV2 = () => {
  const history = useHistory()
  const location = useLocation()
  const { geppoid, syainid } = useParams<{
    geppoid: string
    syainid: string
  }>()
  const 勤怠記号DataMap = new wjcGrid.DataMap<{
    区分コード: string
    表示記号: string
  }>(乗務員勤怠表示記号区分, "区分コード", "表示記号")

  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  //TODO:ページ名称確定必須
  let gridId = "ZyomuinUnkoGeppoV2_GridId"

  //#region [method]

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TZyomuinUnkoGeppo2ListGetReq => {
    return {
      乗務員運行月報2ID: parseInt(geppoid),
      社員ID: parseInt(syainid),
    }
  }

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (
    data: Array<TZyomuinUnkoGeppo2ListGetRes>,
    pageSize: number
  ) => {
    const bindItems: T運行月報リスト[] = data.map((item) => {
      return {
        ...item,
        行ID: Symbol(),
      }
    })
    return new wjCore.CollectionView(bindItems, {
      pageSize,
      calculatedFields: {
        有休_勤怠記号区分コード: (data: TZyomuinUnkoGeppo2ListGetRes) => {
          if (data.勤怠区分コード === e勤怠区分.有給休暇) {
            return "1"
          } else {
            return undefined
          }
        },
        特休_勤怠記号区分コード: (data: TZyomuinUnkoGeppo2ListGetRes) => {
          if (data.勤怠区分コード === e勤怠区分.特別休暇) {
            return "1"
          } else {
            return undefined
          }
        },
        品名_コンテナ: (data: TZyomuinUnkoGeppo2ListGetRes) => {
          if (data.受注配車区分コード === "1") {
            return data.品名
          } else if (data.受注配車区分コード === "2") {
            const elements = []
            if (data.コンテナサイズ名称1)
              elements.push(data.コンテナサイズ名称1)
            if (data.コンテナ軸名称1) elements.push(data.コンテナ軸名称1)
            return elements.join(" ")
          } else {
            return data.品名
          }
        },
        数量: (data: TZyomuinUnkoGeppo2ListGetRes) => {
          const elements = []
          if (data.積載品数量) elements.push(data.積載品数量.toFixed(1))
          if (data.積載品単位名称1) elements.push(data.積載品単位名称1)
          return elements.join(" ")
        },
        長距離フラグ: (data: TZyomuinUnkoGeppo2ListGetRes) => {
          if (data.食事手当) {
            return 1
          } else {
            return undefined
          }
        },
        他部所運行: (data: TZyomuinUnkoGeppo2ListGetRes) => {
          if (data.付替区分コード === e付替区分.他部所) {
            return "1"
          } else {
            return undefined
          }
        },
        乗務員_同乗_売上: (data: TZyomuinUnkoGeppo2ListGetRes) => {
          if (!data.乗務員売上額 && !data.同乗者売上額) return undefined
          return (data.乗務員売上額 ?? 0) + (data.同乗者売上額 ?? 0)
        },
      },

      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })
  }

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: TZyomuinUnkoGeppo2ListGetReq) => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    let currentSearchCondition: TZyomuinUnkoGeppo2ListGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    try {
      const res = await new ZyomuinUnkoGeppoV2Service().getList(
        currentSearchCondition
      )
      const 月報items: TZyomuinUnkoGeppo2ListGetRes[] = []
      res.data.forEach((d) => {
        var 月報item: TZyomuinUnkoGeppo2ListGetRes = d
        月報item.出勤時刻 = d.出勤時刻
          ? dayjs(dayjs(d.勤務日).add(parseInt(d.出勤時刻), "ms")).format(
              "H:mm"
            )
          : ""
        月報item.退勤時刻 = d.退勤時刻
          ? dayjs(dayjs(d.勤務日).add(parseInt(d.退勤時刻), "ms")).format(
              "H:mm"
            )
          : ""
        月報item.勤務時間 = dateUtil.toTimeSpanString(d.勤務時間, "H:mm")
        月報item.勤務時間 =
          月報item.勤務時間 === "0:00" ? "" : 月報item.勤務時間

        月報item.残業時間 = dateUtil.toTimeSpanString(d.残業時間, "H:mm")
        月報item.残業時間 =
          月報item.残業時間 === "0:00" ? "" : 月報item.残業時間

        月報item.深夜時間 = dateUtil.toTimeSpanString(d.深夜時間, "H:mm")
        月報item.深夜時間 =
          月報item.深夜時間 === "0:00" ? "" : 月報item.深夜時間

        月報item.休出時間 = dateUtil.toTimeSpanString(d.休出時間, "H:mm")
        月報item.休出時間 =
          月報item.休出時間 === "0:00" ? "" : 月報item.休出時間

        月報item.拘束時間 = dateUtil.toTimeSpanString(d.拘束時間, "H:mm")
        月報item.拘束時間 =
          月報item.拘束時間 === "0:00" ? "" : 月報item.拘束時間

        月報item.運行外業務時間 = dateUtil.toTimeSpanString(
          d.運行外業務時間,
          "H:mm"
        )
        月報item.運行外業務時間 =
          月報item.運行外業務時間 === "0:00" ? "" : 月報item.運行外業務時間

        月報items.push(月報item)
      })
      if (res.data) {
        const 勤務日1st = res.data.find((d) => d.勤務日 != null)?.勤務日
        if (勤務日1st) {
          set年月(dayjs(勤務日1st).format("YYYY年MM月"))
        }
      }

      const syainRes = await new SyainService().get(syainid)
      set部所名(syainRes.data.部所名)
      set社員番号(syainRes.data.社員コード)
      set氏名(syainRes.data.社員氏名)
      setGridData({ data: createCollectionView(res.data, pageSize) })
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索状態切り替え
    }
  }

  /**
   * 明細グリッドセル結合マネージャー
   */
  class RestrictedMergeManager extends wjcGrid.MergeManager {
    getMergedRange(p: wjcGrid.GridPanel, r: number, c: number, clip = true) {
      var rng = null
      rng = new wjcGrid.CellRange(r, c)

      const 勤務マージ判定用BindList: {
        binding: string
        isRequired: boolean
      }[] = [
        {
          binding: "勤務日",
          isRequired: true,
        },
      ]
      const 勤務マージ対象BindList: string[] = [
        "勤務日",
        "勤務曜日",
        "勤務時間",
        "残業時間",
        "深夜時間",
        "休出時間",
        "拘束時間",
        "運行外業務時間",
        "特休_勤怠記号区分コード",
        "有休_勤怠記号区分コード",
        "走行距離",
      ]
      const 出勤時刻マージ対象BindList: string[] = ["出勤時刻"]
      const 出勤時刻マージ判定用BindList: {
        binding: string
        isRequired: boolean
      }[] = [
        {
          binding: "勤務日",
          isRequired: true,
        },
        {
          binding: "出勤時刻",
          isRequired: false,
        },
      ]
      const 退勤時刻マージ対象BindList: string[] = ["退勤時刻"]
      const 退勤時刻マージ判定用BindList: {
        binding: string
        isRequired: boolean
      }[] = [
        {
          binding: "勤務日",
          isRequired: true,
        },
        {
          binding: "退勤時刻",
          isRequired: false,
        },
      ]
      const 車輌マージ判定用BindList: {
        binding: string
        isRequired: boolean
      }[] = [
        {
          binding: "車輌ID",
          isRequired: false,
        },
      ]
      const 車輌マージ対象BindList: string[] = [
        "車番",
        "車種区分名称1",
        "車種詳細",
        "ETC高速料",
      ]

      const 受注配車マージ判定用BindList: {
        binding: string
        isRequired: boolean
      }[] = [
        {
          binding: "受注配車ID",
          isRequired: true,
        },
      ]
      const 受注配車マージ対象BindList: string[] = [
        "荷主名",
        "コース編集",
        "請求運送料",
        "請求付帯料",
        "請求高速料",
        "付替区分ID",
        "付替区分コード",
        "品名_コンテナ",
        "数量",
      ]
      const is出勤時刻マージCell = (rowNumber: number) => {
        return !出勤時刻マージ判定用BindList.find((bindListItem) => {
          const cellValue = p.getCellData(r, bindListItem.binding, true)
          const prevRowValue = p.getCellData(
            rowNumber - 1,
            bindListItem.binding,
            true
          )
          if (bindListItem.isRequired && !cellValue) return true
          return cellValue !== prevRowValue
        })
      }
      const is退勤時刻マージCell = (rowNumber: number) => {
        return !退勤時刻マージ判定用BindList.find((bindListItem) => {
          const cellValue = p.getCellData(r, bindListItem.binding, true)
          const prevRowValue = p.getCellData(
            rowNumber - 1,
            bindListItem.binding,
            true
          )
          if (bindListItem.isRequired && !cellValue) return true
          return cellValue !== prevRowValue
        })
      }
      const is勤務マージCell = (rowNumber: number) => {
        return !勤務マージ判定用BindList.find((bindListItem) => {
          const cellValue = p.getCellData(r, bindListItem.binding, true)
          const prevRowValue = p.getCellData(
            rowNumber - 1,
            bindListItem.binding,
            true
          )

          if (bindListItem.isRequired && !cellValue) return true
          return cellValue !== prevRowValue
        })
      }

      const is車輌マージCell = (rowNumber: number) => {
        return !車輌マージ判定用BindList.find((bindListItem) => {
          const cellValue = p.getCellData(r, bindListItem.binding, true)
          const prevRowValue = p.getCellData(
            rowNumber - 1,
            bindListItem.binding,
            true
          )
          if (bindListItem.isRequired && !cellValue) return true
          return cellValue !== prevRowValue
        })
      }

      const is受注配車マージCell = (rowNumber: number) => {
        return !受注配車マージ判定用BindList.find((bindListItem) => {
          const cellValue = p.getCellData(r, bindListItem.binding, true)
          const prevRowValue = p.getCellData(
            rowNumber - 1,
            bindListItem.binding,
            true
          )
          if (bindListItem.isRequired && !cellValue) return true
          return cellValue !== prevRowValue
        })
      }

      // ヘッダーの結合
      if (p.cellType === wjcGrid.CellType.ColumnHeader) {
        while (
          rng.col2 < p.columns.length - 1 &&
          p.getCellData(r, c, true) === p.getCellData(r, rng.col2 + 1, true)
        ) {
          rng.col2++
        }
        while (
          rng.col > 0 &&
          p.getCellData(r, c, true) === p.getCellData(r, rng.col - 1, true)
        ) {
          rng.col--
        }
        while (
          rng.row2 < p.rows.length - 1 &&
          p.getCellData(r, c, true) === p.getCellData(rng.row2 + 1, c, true)
        ) {
          rng.row2++
        }
        while (
          rng.row > 0 &&
          p.getCellData(r, c, true) === p.getCellData(rng.row - 1, c, true)
        ) {
          rng.row--
        }
        return rng
      }

      let isSingleCell = false
      // bindListの列が全て同じ値であれば結合する
      if (出勤時刻マージ対象BindList.includes(p.columns[c].binding ?? "")) {
        // セルの現在位置の上のセルと比較
        while (rng.row > 0 && is出勤時刻マージCell(rng.row)) {
          rng.row--
        }
        // セルの現在位置の下のセルと比較
        while (
          rng.row2 < p.rows.length - 1 &&
          is出勤時刻マージCell(rng.row2 + 2)
        ) {
          rng.row2++
        }
        if (rng.isSingleCell) {
          isSingleCell = true
        }
      }
      if (退勤時刻マージ対象BindList.includes(p.columns[c].binding ?? "")) {
        // セルの現在位置の上のセルと比較
        while (rng.row > 0 && is退勤時刻マージCell(rng.row)) {
          rng.row--
        }
        // セルの現在位置の下のセルと比較
        while (
          rng.row2 < p.rows.length - 1 &&
          is退勤時刻マージCell(rng.row2 + 2)
        ) {
          rng.row2++
        }
        if (rng.isSingleCell) {
          isSingleCell = true
        }
      }

      if (勤務マージ対象BindList.includes(p.columns[c].binding ?? "")) {
        // セルの現在位置の上のセルと比較
        while (rng.row > 0 && is勤務マージCell(rng.row)) {
          rng.row--
        }
        // セルの現在位置の下のセルと比較
        while (rng.row2 < p.rows.length - 1 && is勤務マージCell(rng.row2 + 2)) {
          rng.row2++
        }
        if (rng.isSingleCell) {
          isSingleCell = true
        }
      }

      if (車輌マージ対象BindList.includes(p.columns[c].binding ?? "")) {
        // セルの現在位置の上のセルと比較
        while (
          rng.row > 0 &&
          is車輌マージCell(rng.row) &&
          is勤務マージCell(rng.row)
        ) {
          rng.row--
        }
        // セルの現在位置の下のセルと比較
        while (
          rng.row2 < p.rows.length - 1 &&
          is車輌マージCell(rng.row2 + 2) &&
          is勤務マージCell(rng.row2 + 2)
        ) {
          rng.row2++
        }
        if (rng.isSingleCell) {
          isSingleCell = true
        }
      }

      if (受注配車マージ対象BindList.includes(p.columns[c].binding ?? "")) {
        // セルの現在位置の上のセルと比較
        while (rng.row > 0 && is受注配車マージCell(rng.row)) {
          rng.row--
        }
        // セルの現在位置の下のセルと比較
        while (
          rng.row2 < p.rows.length - 1 &&
          is受注配車マージCell(rng.row2 + 2)
        ) {
          rng.row2++
        }
        if (rng.isSingleCell) {
          isSingleCell = true
        }
      }
      if (isSingleCell) {
        rng = null
      }
      return rng
    }
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjcGrid.FlexGrid) => {
    // ヘッダーに行追加
    // header行に一行追加
    // 追加行のみ初期化時に設定
    var extraRow = new wjcGrid.Row()
    extraRow.allowMerging = true
    var columnHeaders = grid.columnHeaders
    columnHeaders.rows.splice(0, 0, extraRow)

    // ヘッダグループのラベルを定義
    columnHeaders.columns.forEach((c, index) => {
      // 固定部分
      switch (c.binding) {
        case "勤務日":
        case "勤務曜日":
          columnHeaders.setCellData(0, index, "日付")
          break
        case "出勤時刻":
        case "退勤時刻":
          columnHeaders.setCellData(0, index, "タイムカード")
          break
        case "勤務時間":
        case "残業時間":
        case "深夜時間":
        case "休出時間":
        case "拘束時間":
        case "運行外業務時間":
          columnHeaders.setCellData(0, index, "勤務時間")
          break
        case "有休_勤怠記号区分コード":
          columnHeaders.setCellData(0, index, "有休")
          break
        case "特休_勤怠記号区分コード":
          columnHeaders.setCellData(0, index, "特休")
          break
        case "車番":
        case "車種区分名称1":
        case "車種詳細":
          columnHeaders.setCellData(0, index, "車輌")
          break
        case "走行距離":
          columnHeaders.setCellData(0, index, "走行距離")
          c.format = "n0"
          break
        case "ETC高速料":
          columnHeaders.setCellData(0, index, "ETC")
          break
        case "荷主名":
          columnHeaders.setCellData(0, index, "荷主")
          break
        case "コース編集":
          columnHeaders.setCellData(0, index, "コース編集")
          break
        case "品名_コンテナ":
          columnHeaders.setCellData(0, index, "品名")
          break
        case "数量":
          columnHeaders.setCellData(0, index, "数量")
          break
        case "乗務員_同乗_売上":
        case "乗務員付帯料":
        case "付帯高速料":
        case "乗務員売上計":
          columnHeaders.setCellData(0, index, "乗務員売上明細")
          break
        case "同乗者フラグ":
          columnHeaders.setCellData(0, index, "同乗")
          break
        case "長距離フラグ":
          columnHeaders.setCellData(0, index, "長距離")
          break
        case "食事手当":
        case "稼働手当車種別掛率区分名称1":
        case "特別手当":
        case "その他手当":
          columnHeaders.setCellData(0, index, "手当")
          break
        case "編集":
          columnHeaders.setCellData(0, index, "編集")
          break
      }
      c.align = "center"
    })

    // フッタ行を生成
    grid.columnFooters.rows.push(new wjcGrid.GroupRow())

    // flexGrid?.bottomLeftCells.setCellData(0, 0, "合計") // 必要なら行ヘッダ入れる
    grid.formatItem.addHandler(formatItem)
    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjcGrid.FlexGrid, e: wjcGrid.FormatItemEventArgs) => {
    if (e.panel === f.cells) {
      const cellBinding = e.getColumn().binding
      let col = f.columns[e.col]
      if (cellBinding !== null && e.getRow().dataIndex !== -1) {
        const dataItem: TZyomuinUnkoGeppo2ListGetRes = e.getRow().dataItem

        switch (col.binding as keyof TZyomuinUnkoGeppo2ListGetRes) {
          case "ETC高速料":
            if (dataItem.受注配車工程不明フラグ === 1) {
              wjCore.toggleClass(e.cell, "warn", true)
            }
            break
          default:
            break
        }
      }
    }
  }

  /**
   * 時間の数値を受け取って、HH:MM形式の文字列を返す関数
   * @param decimalTime
   * @returns
  //  */
  // const formatDecimalTimeToHHMM = (decimalTime: number): string => {
  //   // 時間部分
  //   const hours = Math.floor(decimalTime)
  //   // 分部分 (小数部分を60倍)
  //   const minutes = Math.floor((decimalTime - hours) * 60)

  //   // ゼロ埋めして分を2桁にフォーマット
  //   const formattedMinutes = String(minutes).padStart(2, "0")

  //   // フォーマットした時間と分を返す
  //   return `${hours}:${formattedMinutes}`
  // }

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(100)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)
  const [dataInitialized, setDataInitialized] = useState<boolean>(false)

  //#endregion

  //#region [state]

  const [年月, set年月] = useState<string>("")
  const [氏名, set氏名] = useState<string>("")
  const [社員番号, set社員番号] = useState<string>("")
  const [部所名, set部所名] = useState<string>("")
  const [乗務員運行月報明細2ID, set乗務員運行月報明細2ID] = useState<number>(0)
  const [乗務員運行月報明細更新日時, set乗務員運行月報明細更新日時] =
    useState<string>("")
  const [受注配車ID, set受注配車ID] = useState<number>(0)
  const [受注配車更新日時, set受注配車更新日時] = useState<string>("")
  const [summaryList, setSummaryList] =
    useState<TZyomuinUnkoGeppo2SummaryGetRes>()
  const [, setIsEdited] = useState<boolean>(false)
  // modal
  const [isTeateEditModalShow, setIsTeateEditModalShow] =
    useState<boolean>(false)

  //#endregion

  //#region [effect]

  useEffect(() => {
    document.title = `乗務員運行月報 (新)`
    // 初期表示生成のため画面ロック
    dispatch(画面ロック開始())
    Promise.all([
      new ZyomuinUnkoGeppoV2Service().getSummaryList({
        乗務員運行月報2ID: parseInt(geppoid),
        社員ID: parseInt(syainid),
      }),
    ]).then(([summaryRes]) => {
      if (summaryRes.data.乗務員運行月報2集計List.length > 0) {
        const data = summaryRes.data.乗務員運行月報2集計List[0]
        setSummaryList(data)
        console.log(JSON.stringify(data, null, 2))
      } else {
        setDataInitialized(true)
      }
    })
  }, [])

  useEffect(() => {
    if (!dataInitialized || !flexGrid) return
    // フッタの設定

    // 合計行にて、勤怠の部分はグリッドの集計ではなく勤怠側で集計しているものを表示
    var columnFooters = flexGrid.columnFooters
    columnFooters.columns.forEach((c, index) => {
      switch (c.binding) {
        case "勤務時間":
          columnFooters.setCellData(
            0,
            index,
            summaryList?.勤務時間丸め !== undefined
              ? summaryList.勤務時間丸め
              : ""
          )
          break
        case "残業時間":
          columnFooters.setCellData(
            0,
            index,
            summaryList?.残業時間丸め !== undefined
              ? summaryList.残業時間丸め
              : ""
          )
          break
        case "深夜時間":
          columnFooters.setCellData(
            0,
            index,
            summaryList?.深夜時間丸め !== undefined
              ? summaryList.深夜時間丸め
              : ""
          )
          break
        case "休出時間":
          columnFooters.setCellData(
            0,
            index,
            summaryList?.休出時間丸め !== undefined
              ? summaryList.休出時間丸め
              : ""
          )
          break
        case "拘束時間":
          columnFooters.setCellData(
            0,
            index,
            summaryList?.拘束時間丸め !== undefined
              ? summaryList.拘束時間丸め
              : ""
          )
          break
        case "運行外業務時間":
          columnFooters.setCellData(
            0,
            index,
            summaryList?.運行外業務時間丸め !== undefined
              ? summaryList.運行外業務時間丸め
              : ""
          )
          break
        case "休出_勤怠記号区分コード":
          columnFooters.setCellData(
            0,
            index,
            summaryList?.休出時間 !== undefined
              ? summaryList.休出時間.toString()
              : ""
          )
          break
        case "有休_勤怠記号区分コード":
          columnFooters.setCellData(
            0,
            index,
            summaryList?.有休数 !== undefined
              ? summaryList.有休数.toString()
              : ""
          )
          break
        case "特休_勤怠記号区分コード":
          columnFooters.setCellData(
            0,
            index,
            summaryList?.特休数 !== undefined
              ? summaryList.特休数.toString()
              : ""
          )
          break
        case "走行距離":
          console.log(`走行距離:${summaryList?.走行距離}`)
          columnFooters.setCellData(
            0,
            index,
            summaryList?.走行距離 !== undefined
              ? Math.round(summaryList.走行距離).toLocaleString()
              : ""
          )
          c.format = "F0"
          c.align = "center"
          break
        case "ETC高速料":
          columnFooters.setCellData(
            0,
            index,
            summaryList?.ETC高速料 !== undefined
              ? summaryList.ETC高速料.toLocaleString()
              : ""
          )
          c.format = "F0"
          c.align = "center"
          break
        case "乗務員_同乗_売上":
          columnFooters.setCellData(
            0,
            index,
            summaryList?.乗務員売上額 !== undefined
              ? summaryList.乗務員売上額.toLocaleString()
              : ""
          )
          c.format = "F0"
          c.align = "center"
          break
        case "乗務員付帯料":
          columnFooters.setCellData(
            0,
            index,
            summaryList?.運送料 !== undefined
              ? summaryList.付帯料.toLocaleString()
              : ""
          )
          c.format = "F0"
          c.align = "center"
          break
        case "付帯高速料":
          columnFooters.setCellData(
            0,
            index,
            summaryList?.高速料 !== undefined
              ? summaryList.高速料.toLocaleString()
              : ""
          )
          c.format = "F0"
          c.align = "center"
          break
        case "乗務員売上計":
          columnFooters.setCellData(
            0,
            index,
            summaryList?.乗務員売上額 !== undefined
              ? summaryList.乗務員売上額.toLocaleString()
              : ""
          )
          c.format = "F0"
          c.align = "center"
          break
        case "同乗者フラグ":
          columnFooters.setCellData(
            0,
            index,
            summaryList?.同乗回数 !== undefined
              ? summaryList.同乗回数.toLocaleString()
              : ""
          )
          c.format = "F0"
          c.align = "center"
          break
        case "長距離フラグ":
          columnFooters.setCellData(
            0,
            index,
            summaryList?.長距離回数 !== undefined
              ? summaryList.長距離回数.toLocaleString()
              : ""
          )
          c.format = "F0"
          c.align = "center"
          break
        case "食事手当":
          columnFooters.setCellData(
            0,
            index,
            summaryList?.食事手当 !== undefined
              ? summaryList.食事手当.toLocaleString()
              : ""
          )
          c.format = "F0"
          c.align = "center"
          break
        case "特別手当":
          columnFooters.setCellData(
            0,
            index,
            summaryList?.特別手当 !== undefined
              ? summaryList.特別手当.toLocaleString()
              : ""
          )
          c.format = "F0"
          c.align = "center"
          break
        case "その他手当":
          columnFooters.setCellData(
            0,
            index,
            summaryList?.その他手当 !== undefined
              ? summaryList.その他手当.toLocaleString()
              : ""
          )
          c.format = "F0"
          c.align = "center"
          break
      }
    })
  }, [dataInitialized, flexGrid])

  useEffect(() => {
    if (!summaryList) return

    flexGrid?.formatItem.removeAllHandlers()
    flexGrid?.formatItem.addHandler(formatItem)

    setDataInitialized(true)
  }, [summaryList])

  useEffect(() => {
    if (gridInitialized && dataInitialized) {
      // リストア中フラグON
      setIsRestoreSearching(true)
      // 検索
      search({
        乗務員運行月報2ID: parseInt(geppoid),
        社員ID: parseInt(syainid),
      }).finally(() => {
        dispatch(画面ロック解除())
      })
    }
  }, [gridInitialized, dataInitialized])

  useEffect(() => {
    if (!isTeateEditModalShow && gridInitialized) {
      search({
        乗務員運行月報2ID: parseInt(geppoid),
        社員ID: parseInt(syainid),
      })
    }
  }, [isTeateEditModalShow, gridInitialized])

  //#endregion

  return (
    <>
      <Container fluid>
        {/* 画面タイトル */}
        <Row className="page-title-row">
          <Col className="page-title-col">
            <span className="page-title">乗務員運行月報 (新)</span>
          </Col>
        </Row>
        {/* アラート表示 */}
        <Row>
          <Col>
            <AlertComponent />
          </Col>
        </Row>
        <Row>
          <Col>
            <Card className="w-40rem">
              <Card.Body>
                <Container fluid className="label-form">
                  <Table className="form-table">
                    <tbody>
                      <tr>
                        <th className="min-w-8rem">年月</th>
                        <td>
                          <div className="input-group">
                            <TextInput
                              style={{ width: "9rem" }}
                              id="年月"
                              name="年月"
                              value={年月}
                              setValue={() => {}}
                              isReadOnly></TextInput>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th className="min-w-8rem">部所</th>
                        <td>
                          <TextInput
                            style={{ width: "20rem" }}
                            id="部所名"
                            name="部所名"
                            value={部所名}
                            setValue={() => {}}
                            isReadOnly></TextInput>
                        </td>
                      </tr>
                      <tr>
                        <th className="min-w-8rem">氏名</th>
                        <td>
                          <div className="input-group">
                            <TextInput
                              style={{ width: "5rem" }}
                              id="社員番号"
                              name="社員番号"
                              value={社員番号}
                              setValue={() => {}}
                              isReadOnly></TextInput>
                            <TextInput
                              id="氏名"
                              name="氏名"
                              value={氏名}
                              setValue={() => {}}
                              isReadOnly></TextInput>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </Container>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        {/* 明細部分 */}
        <Row>
          <Col>
            {/* 検索結果カード */}
            <Card>
              <Spinner searching={isSearching}></Spinner>
              <Card.Body>
                <FlexGridOuter
                  flexGrid={flexGrid}
                  setFlexGrid={setFlexGrid}
                  gridConstantProperties={
                    CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS
                  }
                  style={{ maxHeight: "auto", height: "calc(100vh - 33.3rem)" }}
                  gridData={gridData}
                  setGridData={setGridData}
                  pageNumber={pageNumber}
                  gridId={gridId}
                  isShowGridFooter={true}
                  isRestoreSearching={isRestoreSearching}
                  setIsRestoreSearching={setIsRestoreSearching}
                  gridInitialized={gridInitialized}
                  setGridInitialized={setGridInitialized}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  gridInitializedHandler={gridInitializedHandler}
                  isShowGridRowPickupButton={false}
                  hasFilter={false}
                  headerComponent={
                    <div className="d-flex">
                      <Button
                        type="button"
                        variant="secondary"
                        className="ms-1"
                        disabled={history.length <= 1}
                        onClick={() => history.goBack()}>
                        一覧に戻る
                      </Button>
                    </div>
                  }
                  gridProperties={{
                    allowSorting: wjcGrid.AllowSorting.None,
                    allowDragging: wjcGrid.AllowDragging.None,
                    mergeManager: new RestrictedMergeManager(),
                    headersVisibility: wjcGrid.HeadersVisibility.Column,
                  }}>
                  <wjrGrid.FlexGridColumn
                    binding="勤務日"
                    cssClass="read-only-cell"
                    width={30}
                    header="日">
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<TZyomuinUnkoGeppo2ListGetRes>
                      ) => {
                        // 休日カレンダー判定
                        let holidayCssClass = ""
                        if (
                          context.item.日曜フラグ === 1 ||
                          context.item.祝日フラグ === 1
                        ) {
                          holidayCssClass = "holiday-color"
                        }
                        return (
                          <span className={`${holidayCssClass}`}>
                            {dayjs(context.item.勤務日).format("D")}
                          </span>
                        )
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="勤務曜日"
                    cssClass="read-only-cell"
                    width={30}
                    header="曜">
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<TZyomuinUnkoGeppo2ListGetRes>
                      ) => {
                        // 休日カレンダー判定
                        let holidayCssClass = ""
                        if (
                          context.item.日曜フラグ === 1 ||
                          context.item.祝日フラグ === 1
                        ) {
                          holidayCssClass = "holiday-color"
                        }
                        return (
                          <span className={`${holidayCssClass}`}>
                            {context.item.勤務曜日}
                          </span>
                        )
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="出勤時刻"
                    cssClass="text-end"
                    width={55}
                    header="出勤"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="退勤時刻"
                    cssClass="text-end"
                    width={55}
                    header="退勤"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="勤務時間"
                    cssClass="text-end"
                    width={60}
                    header="勤務"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="残業時間"
                    cssClass="text-end"
                    width={60}
                    header="残業"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="深夜時間"
                    cssClass="text-end"
                    width={60}
                    header="深夜"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="休出時間"
                    cssClass="text-end"
                    width={60}
                    header="休出"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="拘束時間"
                    cssClass="text-end"
                    width={60}
                    header="拘束"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="運行外業務時間"
                    cssClass="text-end"
                    width={60}
                    header="運外"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="有休_勤怠記号区分コード"
                    cssClass="read-only-cell"
                    width={45}
                    dataMap={勤怠記号DataMap}
                    header="有休"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="特休_勤怠記号区分コード"
                    cssClass="read-only-cell"
                    width={45}
                    dataMap={勤怠記号DataMap}
                    header="特休"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="車番"
                    align={"left"}
                    cssClass="read-only-cell text-start"
                    width={60}
                    header="車番"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="車種区分名称1"
                    align={"left"}
                    cssClass="read-only-cell text-start"
                    width={80}
                    header="車種"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="車種詳細"
                    align={"left"}
                    dataType="Number"
                    cssClass="read-only-cell text-start"
                    width={120}
                    header="車種詳細"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="走行距離"
                    cssClass="read-only-cell text-end"
                    format="n0"
                    dataType="Number"
                    width={80}
                    header="走行距離"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="ETC高速料"
                    align={"right"}
                    format="n0"
                    dataType="Number"
                    cssClass="read-only-cell text-end"
                    width={80}
                    header="ETC"
                    aggregate={wjCore.Aggregate.Sum}>
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<TZyomuinUnkoGeppo2SummaryGetRes>
                      ) => {
                        // 休日カレンダー判定
                        if (context.item.受注配車工程不明フラグ === 1) {
                          return (
                            <OverlayTrigger
                              placement={"right"}
                              overlay={
                                <Tooltip>
                                  受注配車工程が不明なETCデータが存在します。
                                </Tooltip>
                              }>
                              <div className={`d-table`}>
                                <FontAwesomeIcon
                                  icon={faExclamationTriangle}
                                  className={`d-table-cell align-left pt-1 warn-text`}
                                />
                                <span
                                  className={`d-table-cell align-right w-100`}>
                                  {context.item.ETC高速料}
                                </span>
                              </div>
                            </OverlayTrigger>
                          )
                        } else {
                          return <span>{context.item.ETC高速料}</span>
                        }
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="荷主名"
                    align={"left"}
                    cssClass="read-only-cell text-start"
                    width={120}
                    header="荷主"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="コース編集"
                    align={"left"}
                    cssClass="read-only-cell text-start"
                    width={200}
                    header="コース編集"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="品名_コンテナ"
                    align={"left"}
                    cssClass="read-only-cell text-start"
                    width={80}
                    header="品名"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="数量"
                    align={"right"}
                    cssClass="read-only-cell text-end"
                    dataType="Number"
                    format="n3"
                    width={70}
                    header="数量"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="乗務員_同乗_売上"
                    align={"right"}
                    cssClass="read-only-cell text-end"
                    dataType="Number"
                    format="n0"
                    width={95}
                    header="乗務員売上"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="乗務員付帯料"
                    align={"right"}
                    cssClass="read-only-cell text-end"
                    dataType="Number"
                    format="n0"
                    width={80}
                    header="付帯料"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="付帯高速料"
                    align={"right"}
                    cssClass="read-only-cell text-end"
                    dataType="Number"
                    format="n0"
                    width={80}
                    header="付帯高速料"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="乗務員売上計"
                    align={"right"}
                    cssClass="read-only-cell text-end"
                    dataType="Number"
                    format="n0"
                    width={95}
                    header="乗務員売上計"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="同乗者フラグ"
                    align={"center"}
                    cssClass="read-only-cell text-center"
                    width={45}
                    header="同乗"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="長距離フラグ"
                    align={"center"}
                    cssClass="read-only-cell text-center"
                    width={45}
                    header="長距離"
                    wordWrap={true}></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="食事手当"
                    align={"right"}
                    cssClass="read-only-cell text-end"
                    dataType="Number"
                    format="n0"
                    width={80}
                    header="食事手当"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="稼働手当車種別掛率区分名称1"
                    align={"right"}
                    cssClass="read-only-cell text-end"
                    width={50}
                    header="率"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="特別手当"
                    align={"right"}
                    cssClass="read-only-cell text-end"
                    dataType="Number"
                    format="n0"
                    width={80}
                    header="特別手当"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="その他手当"
                    align={"right"}
                    cssClass="read-only-cell text-end"
                    dataType="Number"
                    format="n0"
                    width={80}
                    header="その他"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="車輌ID"
                    align={"right"}
                    cssClass="read-only-cell text-end"
                    dataType="Number"
                    format="n0"
                    width={80}
                    visible={false}
                    header="車輌ID"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    variant="waiting"
                    header="編集"
                    align={"center"}
                    cssClass="read-only-cell text-center"
                    allowDragging={false}
                    hasFilter={false}
                    allowSorting={false}
                    binding="受注配車ID"
                    allowMerging={true}
                    selectable={false}
                    width={60}
                    isReadOnly>
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<T運行月報リスト>
                      ) => {
                        return (
                          <Button
                            type="button"
                            disabled={
                              !(
                                context.item.受注配車区分コード ===
                                受注配車区分.通常貨物
                              )
                            }
                            className="btn btn-small btn-primary move-edit-page"
                            onClick={() => {
                              set受注配車ID(context.item.受注配車ID)
                              set受注配車更新日時(context.item.受注配車更新日時)
                              set乗務員運行月報明細2ID(
                                context.item.乗務員運行月報明細2ID
                              )
                              set乗務員運行月報明細更新日時(
                                context.item.乗務員運行月報明細更新日時
                              )
                              setIsTeateEditModalShow(true)
                            }}>
                            編集
                          </Button>
                        )
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                </FlexGridOuter>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <TeateEditModalV2
        isShow={isTeateEditModalShow}
        setIsShow={setIsTeateEditModalShow}
        setIsEdited={setIsEdited}
        editItemSource={{
          乗務員運行月報2ID: parseInt(geppoid),
          乗務員運行月報明細2ID: 乗務員運行月報明細2ID,
          社員ID: parseInt(syainid),
          社員番号: 社員番号 ?? "",
          氏名: 氏名 ?? "",
          受注配車ID: 受注配車ID,
          受注配車更新日時: 受注配車更新日時,
          乗務員運行月報明細更新日時: 乗務員運行月報明細更新日時,
        }}></TeateEditModalV2>
    </>
  )
}

export default ZyomuinUnkoGeppoV2
